import React from 'react';
import PropTypes from 'prop-types';

import tagDefineGenerator from './TagDefineGenerator';
import validateProps from './validateProps';

export default class MultiSelectColumn extends React.Component {
    constructor(props) {
        super(props);
    }

    static isGridColumn = true;
    static tagDefineGenerator = tagDefineGenerator;
    static propsValidator = validateProps;

    static propTypes = {
        name: PropTypes.string.isRequired,

        head: PropTypes.string,
        headBold: PropTypes.bool,
        headFontColor: PropTypes.string,
        headOblique: PropTypes.bool,

        bodyAlign: PropTypes.string,
        bodyBold: PropTypes.bool,
        bodyFontColor: PropTypes.string,
        bodyOblique: PropTypes.bool,
        bodyStyleFilter: PropTypes.func,

        tail: PropTypes.string,
        tailAlign: PropTypes.string,
        tailBold: PropTypes.bool,
        tailFontColor: PropTypes.string,
        tailOblique: PropTypes.bool,

        width: PropTypes.number,
        widthFixed: PropTypes.bool,

        readonly: PropTypes.bool,
        cellReadonlyFilter: PropTypes.func,
        required: PropTypes.bool,
        hidden: PropTypes.bool,

        onChange: PropTypes.func,
        onBlur: PropTypes.func,

        cellCodeFilter: PropTypes.func,
        code: PropTypes.string,
        prefix: PropTypes.string,
        excludeCodes: PropTypes.string,
        arrayCode: PropTypes.string
    };

    render() {
        return null;
    }
}
